import React from "react"
import DownArrow from "../../icons/DownTriangleGrey.svg"
import CloseModalIcon from "../../icons/close_modal.svg"
import {
  setDataQualityConfigModal,
  setBusinessQualityConfigModal,
} from "./DataQualitySlice"
import { useAppDispatch, useAppSelector } from "../../util/hooks"

export default function ManualConfig() {
  const dispatch = useAppDispatch()
  const modalData = useAppSelector(
    (state) => state.dataQuality.manualRulesModalData,
  )
  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault()
    console.log("Form Submitted")
  }

  const handleCloseDialog = () => {
    dispatch(setDataQualityConfigModal(false))
    dispatch(setBusinessQualityConfigModal(false))
  }

  return (
    <div className="flex flex-col gap-4 bg-white w-[600px] rounded relative">
      <div className="flex w-full justify-center items-center font-bold text-base bg-bgRed-100 h-[68px] rounded-t">
        <p className="text-lg">Configuration</p>
      </div>

      <form onSubmit={handleSubmit} className="flex flex-col gap-4 px-10 py-4">
        <div className="flex flex-col gap-2">
          <label className="font-bold text-base">Dataset Applied</label>
          <input
            type="text"
            placeholder="Sales"
            value={modalData.dataset}
            className="h-[40px] rounded text-base border border-customGrey-400 px-4 outline-none w-full text-customGrey-450"
            disabled
          />
        </div>
        <div className="flex flex-col gap-2">
          <label className="font-bold text-base">Columns Applied</label>
          <div className="flex border border-customGrey-400 rounded px-4">
            <input
              className="grow rounded h-10 outline-none"
              type="text"
              value={"Product Desc., Sales Value, Sales Volume"}
            />
            <img src={DownArrow} alt="" />
          </div>
        </div>
        <div className="flex flex-col gap-2">
          <label className="font-bold text-base">Date Added</label>
          <input
            type="text"
            placeholder="09-08-2024"
            value={"09-08-2024"}
            className="h-[40px] rounded text-base border border-customGrey-400 px-4 outline-none w-full text-customGrey-450"
            disabled
          />
        </div>
        <div className="flex flex-col gap-2">
          <label className="font-bold text-base">Threshold</label>
          <input
            type="text"
            placeholder="Threshold"
            value={"75%"}
            className="h-[40px] rounded text-base border border-customGrey-400 px-4 outline-none w-full"
          />
        </div>
        <div className="flex justify-end">
          <button className="mt-2 w-[103px] h-7 bg-dpTheme-main text-white rounded-md cursor-pointer text-xs transition duration-300 ease-in-out transform hover:scale-105 hover:shadow-lg active:scale-95 active:shadow-inner focus:outline-none">
            Save
          </button>
        </div>
        <hr className="mb-5 mt-2" />
      </form>

      {/* close modal */}
      <button onClick={handleCloseDialog} className="absolute top-3 right-4">
        <img src={CloseModalIcon} alt="" />
      </button>
    </div>
  )
}
